// Api.js

import React from 'react';

export const GoogleLoginButton = ({ onClick }) => (
  <button onClick={onClick} type="button" className="login-btn login-with-google-btn">
    Login With Google
  </button>
);

export const GitHubLoginButton = ({ onClick }) => (
  <button onClick={onClick} type="button" className="login-btn login-with-github-btn">
    Login With GitHub
  </button>
);

export const FacebookLoginButton = ({ onClick }) => (
  <button onClick={onClick} type="button" className="login-btn login-with-facebook-btn">
    Login With Facebook
  </button>
);

export const LinkedInLoginButton = ({ onClick }) => (
  <button onClick={onClick} type="button" className="login-btn login-with-linkedin-btn">
    Login With LinkedIn
  </button>
);

export const PhoneLoginButton = ({ onClick }) => (
  <button onClick={onClick} type="button" className="login-btn login-with-phone-btn">
    Login With Phone Number
  </button>
);